export const TYPE_TX = {
    ADJUSTMENT: 'adjustment',
    BONUS_CREDIT: 'bonus_credit',
    BONUS_REDUCE: 'bonus_reduce',
    BONUS_REFUND: 'bonus_refund',
    DEPOSIT: 'deposit',
    NEGATIVE_BALANCE_CORRECTION: 'negative_balance_correction',
    REFUND_AFTER_DECLINE: 'refund_after_decline',
    WITHDRAW: 'withdraw',
}

export const STATE_TX = {
    COMPLETED: 'completed',
    ERROR: 'error',
    PROCESSING: 'processing',
    REJECTED: 'rejected',
}

export const TRANSACTION_SIDES = {
    DOWN: 'down',
    UP: 'up',
}

export const STATUS_TX = {
    DEPOSIT_CREATED: 'deposit_created', // допозит создан
    DEPOSIT_ERROR: 'deposit_error', // ошибка (общая)
    DEPOSIT_SUCCESS: 'deposit_success', // допозит успешно получен
    DEPOSIT_FAILURE: 'deposit_failure', // депозит неполучен
    DEPOSIT_COMPLETED: 'deposit_completed', // депозит пользователя пополнен
    DEPOSIT_DX_ERROR: 'deposit_dx_error', // депозит откленен платформой DX Trade

    CREATED: 'created',
    ERROR: 'error',
    COMPLETED: 'completed',

    PAYOUT_CREATED: 'payout_created', // вывод создан
    PAYOUT_ERROR: 'payout_error', // ошибка (общая)
    PAYOUT_DX_REJECT: 'payout_dx_reject', // вывод откленен платформой DX Trade
    PAYOUT_WAITING_DEALER: 'waiting_dealer', // вывод ожидает решения Миши
    PAYOUT_WAITING_MANAGER: 'waiting_manager', // вывод ожидает решения оператора
    PAYOUT_APPROVED: 'payout_approved', // вывод одобрен оператором
    PAYOUT_DECLINED: 'payout_declined', // вывод отклонен оператором
    PAYOUT_SUCCESS: 'payout_success', // средства отправлены в платежную систему
    PAYOUT_FAILURE: 'payout_failure', // платежная система вернула ошибку
    PAYOUT_COMPLETED: 'payout_completed', // платежная система вернула успешный ответ

    BONUS_CREDIT_INIT: 'bonus_credit_init',
    BONUS_CREDITED: 'bonus_credited',
    BONUS_CREDIT_ERROR: 'bonus_credit_error',
    BONUS_CREDIT_DECLINE: 'bonus_credit_decline',
    BONUS_REDUCE_CREATED: 'bonus_reduce_created',
    BONUS_REDUCED: 'bonus_reduced',
    BONUS_REDUCE_ERROR: 'bonus_reduce_error',
    BONUS_REDUCE_DECLINE: 'bonus_reduce_decline',
    BONUS_WAGERED: 'bonus_wagered',
    BONUS_CANCELED: 'bonus_canceled',
    BONUS_WAITING_DEALER: 'bonus_waiting_dealer',
    BONUS_REFUND: 'bonus_refund',
}
